import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-scroll';
import { bindActionCreators } from 'redux';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';
import { isNullOrUndefined } from '../../store/storeFunctions';

import './badge.scss';

import StableBadge from "../../img/crifBusinessEliteGRBadge.svg";
import TopStableBadge from "../../img/crifTopBusinessEliteGRBadge.svg";

class Badge extends React.Component {

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate() {
        this.getData();
    }

    getData() {
        const isLoading = this.props.entityInfos[this.props.entityId] && this.props.entityInfos[this.props.entityId].isRequesting === true;
        const entityInfo = this.props.entityInfos[this.props.entityId] && this.props.entityInfos[this.props.entityId].result;

        if (!isLoading && !isNullOrUndefined(entityInfo) && entityInfo.topStableCompany == null && entityInfo.stableCompany == null) {
            this.props.ensureEntityInfo(this.props.entityId, true);
        }
    }

    render() {
        const entityInfo = this.props.entityInfos[this.props.entityId] && this.props.entityInfos[this.props.entityId].result;

        if (isNullOrUndefined(entityInfo) || (!entityInfo.topStableCompany && !entityInfo.stableCompany))
            return <></>;

        const sectionName = this.props.isShortReport ? "ShortReportRatingData" : "RatingData";
        const badgeSource = entityInfo.topStableCompany ? TopStableBadge : StableBadge;

        return (
            <div className='badge-row'>
                <Link to={sectionName} smooth={true} duration={100}>
                    <img src={badgeSource} className="badge-img" />
                </Link>
            </div>
        );
    }


}

export default withLocalize(connect(
    state => ({ ...state.entityIdentRow }),
    dispatch => bindActionCreators({ ...entityIdentRowActions }, dispatch)
)(Badge));